/** @format */

import { all, takeLatest } from "redux-saga/effects";
import * as general from "./general";
export function* watchUsers() {
  yield all([takeLatest("AUTH_FETCH", general.authWatcher)]);
}
